export const USER_REQUEST = 'USER_REQUEST'
export const USER_SUCCESS = 'USER_SUCCESS'
export const USER_ERROR = 'USER_ERROR'
export const DIARY_DATA = 'DIARY_DATA'
export const CLEAR_DIARY_DATA = 'CLEAR_DIARY_DATA'
export const CLASSROOM_REQUEST = 'CLASSROOM_REQUEST'
export const SET_CLASSROOM_LIST = 'SET_CLASSROOM_LIST'
export const SET_DIARY = 'SET_DIARY'
export const CHECK_DIARY_DATE = 'CHECK_DIARY_DATE'
export const SET_DIARY_DATE = 'SET_DIARY_DATE'
export const UPDATE_STUDENT = 'UPDATE_STUDENT'
export const UPDATE_STUDENT_DIARY = 'UPDATE_STUDENT_DIARY'
export const UPDATE_MENU_DIARY = 'UPDATE_MENU_DIARY'
export const PUBLISH_DIARY = 'PUBLISH_DIARY'
export const REFRESH_DIARY = 'REFRESH_DIARY'

export const CHECK_VERSION = 'CHECK_VERSION'
export const NEW_VERSION_DETECTED = 'NEW_VERSION_DETECTED'



// WEBPACK FOOTER //
// ./src/store/actions/user.js